import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getOperationsSelector } from '../selectors'
import { saveOperations } from '../store/operations.actions'
import { OperationsConstants } from '../store/operations.constants'
import { IOperationsState } from '../store/operations.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const operationsState: IOperationsState = yield select(getOperationsSelector)
  const { successfulAttempt } = operationsState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.operationsStateList && pcrDoc.patient?.operationsStateList.length) {
        const index = pcrDoc.patient?.operationsStateList?.findIndex(
          (operations) => operations.key === operationsState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.operationsStateList[index].successfulAttempt !== successfulAttempt) {
            yield put(saveOperations())
          }
        }
      } else {
        yield put(saveOperations())
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([OperationsConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
